import axios from 'axios';

export default () =>
  axios.get(`/v1/announcements/has-unread`).then(({ data }) => data.data.has_unread);
